import { useState, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { getIpData } from './utils/api';
// Components
import { Layout, Search, Card, Map, ScrollToTop } from './components';

const GlobalStyles = createGlobalStyle`
  html, body, #root {
    padding: 0;
    margin: 0;
    height: 100%;
    line-height: 1.5;
    font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,
      "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
      "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    background-color: rgb(243, 244, 246);
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  h1, h2, p {
    margin: 0;
  }

  a {
    color: inherit;
    text-decoration: inherit;
  }

  img {
    display: block;
  }
`;

const Heading = styled.h1`
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 600;
  text-align: center;
  color: white;
`;

function App() {
  const [data, setData] = useState(null);

  const position = data ? [data.latitude, data.longitude] : undefined;

  useEffect(() => {
    let isMounted = true;

    (async () => {
      try {
        const res = await getIpData();
        isMounted && setData(res.data);
      } catch (err) {
        console.log(err.message);
      }
    })();

    return () => (isMounted = false);
  }, []);

  const handleOnSearch = async ip => {
    try {
      const res = await getIpData(ip);
      setData(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  return (
    <>
      <GlobalStyles />

      <Layout
        header={
          <>
            <Heading>IP Address Tracking</Heading>
            <Search onSearch={handleOnSearch} />
          </>
        }
      >
        <Card data={data} />
        <Map position={position} />
        <ScrollToTop />
      </Layout>
    </>
  );
}

export default App;
